import type { ReactNode } from "react";
import { cn } from "@/shared/cn";

export interface StepHeaderControl {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

export function HeaderButton({
  children,
  onClick,
  disabled,
  primary = false,
  title,
}: {
  children: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  primary?: boolean;
  title?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={cn(
        "inline-flex h-[32px] items-center gap-[4px] whitespace-nowrap rounded-[var(--radius-md)] border px-[12px]",
        "font-(family-name:--font-display) text-sm font-medium disabled:cursor-not-allowed disabled:opacity-40",
        primary
          ? "border-transparent bg-[var(--color-text-strong)] text-[var(--color-paper)] transition-opacity duration-[var(--duration-fast)] hover:opacity-90"
          : "border-[var(--color-border-strong)] bg-[var(--color-paper)] text-[var(--color-text-strong)] hover:bg-[var(--color-fill-soft)]",
      )}
    >
      {children}
    </button>
  );
}
